import {
  createOfferDetailsLink,
  MENU_ITEMS
} from 'src/features/dashboard/duck/consts'
import routes from 'src/utils/routes'
import { LANGUAGE_KEYS } from 'src/utils/lang'

const SAFE_CTA_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:']

const getCtaLink = cta => {
  if (!cta?.url) return null

  try {
    const url = new URL(cta.url, 'https://notifications.invalid')
    if (!SAFE_CTA_PROTOCOLS.includes(url.protocol)) return null

    const locale = LANGUAGE_KEYS.find(language =>
      url.pathname.startsWith(`/${language}/`)
    )
    const pathname = locale
      ? url.pathname.slice(locale.length + 1)
      : url.pathname

    if (
      ['http:', 'https:'].includes(url.protocol) &&
      (pathname === routes.APP_BASE_PATH ||
        pathname.startsWith(`${routes.APP_BASE_PATH}/`))
    ) {
      // Backend app links can point at a different deployment of this frontend.
      return {
        url: `${pathname}${url.search}${url.hash}`,
        title: cta.title,
        internal: true
      }
    }
  } catch (error) {
    return null
  }

  return { url: cta.url, title: cta.title, internal: false }
}

export const getNotificationLink = notification => {
  if (notification.invoice?.id && notification.cta?.url) {
    return getCtaLink(notification.cta)
  }

  if (notification.offer?.referenceNumber) {
    return {
      url: createOfferDetailsLink(notification.offer.referenceNumber),
      title: notification.offer.referenceNumber,
      internal: true
    }
  }

  if (notification.transportationOrder?.referenceNumber) {
    const referenceNumber = notification.transportationOrder.referenceNumber
    return {
      url: `${routes.APP_DASHBOARD}?tab=${
        MENU_ITEMS.ORDER_DETAILS
      }&id=${encodeURIComponent(referenceNumber)}`,
      title: referenceNumber,
      internal: true
    }
  }

  return getCtaLink(notification.cta)
}
